import apis from "../../core/apis.js";

class CorporateInvoiceItemResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.corporateInvoiceItems).get(options);
  }

  get(id) {
    return this.$resource(apis.corporateInvoiceItems + id).get();
  }

  search(search = "") {
    return this.$resource(apis.corporateInvoiceItems).get({ search });
  }

  post(item) {
    return this.$resource(apis.corporateInvoiceItems).save(item);
  }

  update(id, item) {
    return this.$resource(apis.corporateInvoiceItems + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default CorporateInvoiceItemResource;



// WEBPACK FOOTER //
// ./src/resources/corporateInvoiceItem/corporateInvoiceItem.resource.js